// Helper para URLs de midia. Quando a midia vem do R2 (URL contem
// /media/), anexa ?token=<jwt> para o middleware isAuthMedia aceitar
// — necessario porque <img>/<audio>/<video> nao suportam Authorization
// header custom em load de recurso.
//
// Quando a midia ainda esta em /public/ (legacy ou R2 nao habilitado
// no servidor), nao anexa nada: o /public eh static do Express e nao
// exige auth.

const withMediaToken = (url) => {
  if (!url || typeof url !== "string") return url;
  if (!url.includes("/media/")) return url;
  try {
    const raw = localStorage.getItem("token");
    if (!raw) return url;
    const token = JSON.parse(raw);
    if (!token) return url;
    const sep = url.includes("?") ? "&" : "?";
    return `${url}${sep}token=${encodeURIComponent(token)}`;
  } catch {
    return url;
  }
};

export default withMediaToken;
